import { DateStr, toDateRange } from '@mi-front/core';
import pick from 'lodash/pick';
import moment from 'moment';
import { apiClient } from '../../../../../api';
import { useTimezone } from '../../../../../core/hooks';
import { useStationsQueryParamParser } from '../../../../../core/hooks/useStationsQueryParamParser';
import { ReportView } from '../../../../../core/reports/components/ReportView';
import { useStationsWithAudit } from '../../../hooks/useStationsWithAudit';
import { GlobalSchedulesNoMatchesReportForm } from './form/form';
import { GlobalSchedulesNoMatchesReportResult } from './result/result';
import { GlobalSchedulesNoMatchesReport } from './types';

type Props = Record<string, never>;

export function GlobalSchedulesNoMatchesReportView(p: Props) {
  const stations = useStationsWithAudit();
  const contextTz = useTimezone();

  const defaultValues = {
    ...toDateRange(moment().format('YYYY-MM-DD') as DateStr),
    includeMissingAudio: false,
    stations: [],
    timezone: contextTz,
  };

  return (
    <ReportView<GlobalSchedulesNoMatchesReport>
      defaultValues={defaultValues}
      download={{
        filename: 'schedules-no-matches-report',
      }}
      queryParamsTransform={{
        includeMissingAudio: {
          parse: (value: string) => value === 'true',
        },
        stations: useStationsQueryParamParser(),
      }}
      reportFn={(config, format) => {
        return apiClient.audit.reportGlobalSchedulesNoMatches({
          ...pick(config, 'from', 'to'),
          includeMissingAudio: config.includeMissingAudio,
          stationsIds: (!config.stations.length ? stations : config.stations).map((s) => s.id),
          pageSize: 99999,
          options: {
            format: format,
            timezone: config.timezone || undefined,
          },
        });
      }}
      Form={GlobalSchedulesNoMatchesReportForm}
      Result={GlobalSchedulesNoMatchesReportResult}
    />
  );
}
